import { Boom } from '@meshwatch/types';

import { boomify } from '../rest';
import { FormErrorsBoom } from '../validation/types';

export type ServiceResponse<T> = {
  statusCode: number;
  body: T;
};

abstract class BaseService {
  protected errorServiceResponse = <K>(error: Error): ServiceResponse<FormErrorsBoom<K>> => {
    return this.serviceResponseFromBoom(boomify(error));
  };

  protected serviceResponseFromBoom = <K>(boom: Boom<K>): ServiceResponse<FormErrorsBoom<K>> => {
    return {
      statusCode: boom.statusCode,
      body: boom,
    };
  };

  protected serviceResponse = <T>(body: T): ServiceResponse<T> => {
    return { statusCode: 200, body };
  };

  protected tryExecute = async <T>(
    f: () => Promise<ServiceResponse<T>>
  ): Promise<ServiceResponse<T | FormErrorsBoom<T>>> => {
    return f().catch(error => this.errorServiceResponse<T>(error as Error));
  };
}

export default BaseService;
